export default __webpack_public_path__ + "static/media/petit_palais_lanscape.2903d1ef.jpg";